export default {
  clientAddressResults(currentState, value) {
    const state = currentState;
    state.clientAddressResults = Object.assign([], value);
  },
};
